import {IPhoneFieldValue} from "@pg-design/phone-input-module";

import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {useAppDispatch} from "../../store/hooks";
import {isRtkqMutationError} from "../../store/utils/is_rtkq_mutation_error";
import {usePatchUserProfileMutation} from "../../user/api/patch_user_profile";
import {saveWizardDraft} from "../state/registration_flow_slice";
import {getProfilePhoneString, isSamePhone} from "../utils/registration_wizard_phone";
import {clearSmsCodeCooldown} from "../utils/registration_wizard_sms_cooldown";

interface IUseRegistrationWizardAccountPhoneParams {
    profilePhone: IPhoneFieldValue | null;
    setPhoneError: (message: string) => void;
    onAdvance: () => Promise<void>;
}

/** Account path of the phone step: stores a changed phone in the profile, then moves on to the verification */
export const useRegistrationWizardAccountPhone = (params: IUseRegistrationWizardAccountPhoneParams) => {
    const {profilePhone, setPhoneError, onAdvance} = params;
    const dispatch = useAppDispatch();
    const [patchUserProfile] = usePatchUserProfileMutation();

    const saveAccountPhone = async (phone: IPhoneFieldValue) => {
        if (!isSamePhone(phone, profilePhone)) {
            const response = await patchUserProfile({phone: getProfilePhoneString(phone)});

            if (isRtkqMutationError(response)) {
                const phoneError = (response.error as {data?: {phone?: string[] | string}}).data?.phone;

                if (phoneError) {
                    setPhoneError(Array.isArray(phoneError) ? phoneError.join(", ") : phoneError);
                } else {
                    dispatch(addNotification({notification: defaultAPIErrorNotification}));
                }

                return;
            }

            clearSmsCodeCooldown("profile");
        }

        dispatch(saveWizardDraft({phone}));
        await onAdvance();
    };

    return {saveAccountPhone};
};
import {IPhoneFieldValue} from "@pg-design/phone-input-module";

import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {useAppDispatch} from "../../store/hooks";
import {isRtkqMutationError} from "../../store/utils/is_rtkq_mutation_error";
import {usePatchUserProfileMutation} from "../../user/api/patch_user_profile";
import {saveWizardDraft} from "../state/registration_flow_slice";
import {getProfilePhoneString, isSamePhone} from "../utils/registration_wizard_phone";
import {clearSmsCodeCooldown} from "../utils/registration_wizard_sms_cooldown";

interface IUseRegistrationWizardAccountPhoneParams {
    profilePhone: IPhoneFieldValue | null;
    setPhoneError: (message: string) => void;
    onAdvance: () => Promise<void>;
}

/** Account path of the phone step: stores a changed phone in the profile, then moves on to the verification */
export const useRegistrationWizardAccountPhone = (params: IUseRegistrationWizardAccountPhoneParams) => {
    const {profilePhone, setPhoneError, onAdvance} = params;
    const dispatch = useAppDispatch();
    const [patchUserProfile] = usePatchUserProfileMutation();

    const saveAccountPhone = async (phone: IPhoneFieldValue) => {
        if (!isSamePhone(phone, profilePhone)) {
            const response = await patchUserProfile({phone: getProfilePhoneString(phone)});

            if (isRtkqMutationError(response)) {
                const phoneError = (response.error as {data?: {phone?: string[] | string}}).data?.phone;

                if (phoneError) {
                    setPhoneError(Array.isArray(phoneError) ? phoneError.join(", ") : phoneError);
                } else {
                    dispatch(addNotification({notification: defaultAPIErrorNotification}));
                }

                return;
            }

            clearSmsCodeCooldown("profile");
        }

        dispatch(saveWizardDraft({phone}));
        await onAdvance();
    };

    return {saveAccountPhone};
};
